<div #mapContainer style="height: 0px;width: 0px;z-index: -1;"></div>
<router-outlet></router-outlet>